import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/LogoLight.png'
import _imports_1 from '../assets/images/LogoDark.png'


_pushScopeId("data-v-0ba5630c")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  class: "light",
  src: _imports_0
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "dark",
  src: _imports_1
}, null, -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("figure", null, _hoisted_3))
}